// テーマ（ライト/ダーク）管理。
// - 既定はシステム設定（prefers-color-scheme）に追従。
// - ユーザーが明示的に選ぶと localStorage に保存し、以後はそれを優先。
// - <html> の `dark` クラスの有無で Tailwind の dark バリアントを切り替える。

export type ThemePref = "light" | "dark" | "system";
export type ResolvedTheme = "light" | "dark";

const STORAGE_KEY = "dm-theme";

const media = () => window.matchMedia("(prefers-color-scheme: dark)");

export function getStoredPref(): ThemePref {
  const v = localStorage.getItem(STORAGE_KEY);
  return v === "light" || v === "dark" ? v : "system";
}

export function resolveTheme(pref: ThemePref = getStoredPref()): ResolvedTheme {
  if (pref === "system") return media().matches ? "dark" : "light";
  return pref;
}

function apply(resolved: ResolvedTheme) {
  document.documentElement.classList.toggle("dark", resolved === "dark");
  document.documentElement.style.colorScheme = resolved;
}

// アプリ起動時に一度呼ぶ。システム設定の変化にも追従する（未指定時のみ）。
export function initTheme() {
  apply(resolveTheme());
  media().addEventListener("change", () => {
    if (getStoredPref() === "system") apply(resolveTheme("system"));
  });
}

// テーマを設定（"system" で保存を消してシステム追従に戻す）。
export function setThemePref(pref: ThemePref) {
  if (pref === "system") localStorage.removeItem(STORAGE_KEY);
  else localStorage.setItem(STORAGE_KEY, pref);
  apply(resolveTheme(pref));
}
